"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Userspaces = void 0;
const gearbox_1 = require("@busy-human/gearbox");
const __1 = require("../..");
const Calendars_1 = require("../Calendars");
var Userspaces;
(function (Userspaces) {
    function Defaults() {
        return {
            name: {
                firstName: '',
                lastName: '',
                fullName: ''
            },
            email: '',
            phone: '',
            defaultCalendar: null,
            calendarConnections: [],
            timezone: null,
            timesAvailable: [{
                    startTime: 9,
                    endTime: 17,
                    days: [__1.Weekday.MON, __1.Weekday.TUE, __1.Weekday.WED, __1.Weekday.THU, __1.Weekday.FRI]
                }],
            setupCompleted: [],
            userDidSignupFromMeetingInvite: false
        };
    }
    Userspaces.Defaults = Defaults;
    Userspaces.Relationships = {
        calendars: ["Calendars", Calendars_1.Calendars.CollectionClass]
    };
    class CollectionClass extends gearbox_1.CollectionEntity {
        constructor() {
            super(...arguments);
            this.relationships = Userspaces.Relationships;
        }
        defaults() {
            return Defaults();
        }
    }
    Userspaces.CollectionClass = CollectionClass;
    Userspaces.Collection = new CollectionClass({ path: '/Userspaces' });
})(Userspaces = exports.Userspaces || (exports.Userspaces = {}));
//# sourceMappingURL=index.js.map